import { Calendar } from './Calendar';
import { Provider } from '../Context';
export function CalendarWithContext(props) {
    const { onChange, value, locale, timeZone, weekStartsOn, min, max, onFocus, onBlur, onKeyDown } = props;
    return (<Provider onChange={onChange} value={value} locale={locale} timeZone={timeZone} weekStartsOn={weekStartsOn} min={min} max={max} onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown}>
      <Calendar />
    </Provider>);
}
